import React from "react";
import RadioButton from "./RadioButton";
import PercentInput from "./PercentInput";

const selectStyle = {
  width: "100%",
  backgroundColor: "#ffffff",
  border: "none",
  borderRadius: "0.5rem",
  padding: "0.75rem",
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  outline: "none",
  fontSize: "0.9rem",
  fontFamily: "Inter, sans-serif",
  cursor: "pointer",
};

const NineDays = ({
  onPercentChange,
  onFiveDaysChange,
  formErrors,
  formValidated,
  percentChoice,
  setPercentChoice,
  percent,
  validated,
}) => {
  const handleSelectChange = () => {
    const select75 = document.getElementById("9Periodes75");
    const select60 = document.getElementById("9Periodes60");
    const value75 = parseFloat(select75.value) || 0;
    const value60 = parseFloat(select60.value) || 0;
    const total = value75 + value60;
    const index60 = select60.selectedIndex;
    const index75 = select75.selectedIndex;
    onFiveDaysChange(total, index60, index75);
  };

  return (
    <div
      style={{
        backgroundColor: "#f2f3fe",
        borderRadius: "0.75rem",
        padding: "2rem",
        border: formErrors.percent ? "1.5px solid #ba1a1a" : "none",
      }}
      id="secondaireNineInputField"
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        <RadioButton
          id="9DaysSelect"
          name="9DaysOption"
          checked={percentChoice === "predefined"}
          onChange={() => setPercentChoice("predefined")}
          label="Sélectionner les périodes de congé (9 jours)"
        />

        {percentChoice === "predefined" && (
          <div style={{ marginTop: "0.75rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
            <p style={{ fontSize: "0.85rem", color: "#414751", lineHeight: 1.5, margin: 0 }}>
              SECONDAIRE — CYCLE DE 9 JOURS : Indiquez le nombre de périodes et la durée (60 ou 75 minutes) par cycle de 9 jours. Exemple : 4 périodes de 75 minutes.
            </p>
            <div>
              <label
                htmlFor="9Periodes75"
                style={{ fontSize: "0.875rem", fontWeight: 600, color: "#414751", display: "block", marginBottom: "0.4rem" }}
              >
                Nombre de périodes de 75 minutes
              </label>
              <select id="9Periodes75" onChange={handleSelectChange} defaultValue="0" style={selectStyle}>
                <option value="0">0 période</option>
                <option value="4.07">1 période (4,07%)</option>
                <option value="8.13">2 périodes (8,13%)</option>
                <option value="12.20">3 périodes (12,20%)</option>
                <option value="16.26">4 périodes (16,26%)</option>
                <option value="20.33">5 périodes (20,32%)</option>
                <option value="24.39">6 périodes (24,39%)</option>
                <option value="28.46">7 périodes (28,46%)</option>
                <option value="32.52">8 périodes (32,52%)</option>
              </select>
            </div>
            <div>
              <label
                htmlFor="9Periodes60"
                style={{ fontSize: "0.875rem", fontWeight: 600, color: "#414751", display: "block", marginBottom: "0.4rem" }}
              >
                Nombre de périodes de 60 minutes
              </label>
              <select id="9Periodes60" onChange={handleSelectChange} defaultValue="0" style={selectStyle}>
                <option value="0">0 période</option>
                <option value="3.25">1 période (3,25%)</option>
                <option value="6.50">2 périodes (6,50%)</option>
                <option value="9.76">3 périodes (9,76%)</option>
                <option value="13">4 périodes (13%)</option>
                <option value="16.26">5 périodes (16,26%)</option>
                <option value="19.51">6 périodes (19,51%)</option>
              </select>
            </div>
            {formErrors.percent && (
              <p style={{ color: "#ba1a1a", fontSize: "0.8rem", margin: 0 }}>{formErrors.percent}</p>
            )}
          </div>
        )}

        <div style={{ borderTop: "1.5px solid #e2e4ea", margin: "0.75rem 0" }} />

        <RadioButton
          id="9DaysAutre"
          name="9DaysOption"
          checked={percentChoice === "other"}
          onChange={() => setPercentChoice("other")}
          label="Autre (veuillez indiquer le pourcentage ci-dessous)"
        />

        {percentChoice === "other" && (
          <div style={{ marginTop: "0.5rem" }}>
            <PercentInput
              value={percent}
              onChange={onPercentChange}
              error={formErrors.percent}
              validated={validated}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NineDays;
